import { consts, ToastifyType } from '@allesauto/utils/consts';
import { ErrorResponse } from '@apollo/client/link/error';
import Router from 'next/router';

import config from './config';

export default function handler(errorResponse: ErrorResponse) {
  const { graphQLErrors, networkError, operation } = errorResponse;

  if (graphQLErrors && process.env.APP_ENV !== 'production') {
    graphQLErrors.forEach(({ message, path }) => {
      // eslint-disable-next-line no-console
      console.error(
        `[GraphQL error]: Message: ${JSON.stringify(
          message
        )}, Path: ${JSON.stringify(path)}`
      );
    });
  }

  if (networkError && process.env.APP_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.log(`[Network error]: ${networkError}`);
  }

  // treating the expired access token separately and showing a different error message
  const isTokenExpired =
    graphQLErrors &&
    graphQLErrors.find(
      ({ message }) => message === consts.INVALID_TOKEN_ERROR_MESSAGE
    );

  if (isTokenExpired) {
    import('@allesauto/core/toastify').then((module) => {
      module.toastifyFactory(
        ToastifyType.WARNING,
        (intlFormat) => intlFormat('global.ERRORS.TOKEN_EXPIRED.HEADER'),
        (intlFormat) => intlFormat('global.ERRORS.TOKEN_EXPIRED.TEXT')
      );
    });

    Router.replace('/account/login');
  }

  // if the token is expired and there are some other errors - show another toast for this error (if necessary)
  // if it's not then just go with the standard logic
  if (
    (!isTokenExpired || graphQLErrors.length > 1) &&
    (!config.bypass || !config.bypass.includes(operation.operationName))
  ) {
    // default type & text for an error message
    let type = ToastifyType.ERROR;
    let headerKey = 'global.ERRORS.DEFAULT.HEADER';
    let textKey = 'global.ERRORS.DEFAULT.TEXT';

    const customError = config.customErrors
      ? config.customErrors[operation.operationName]
      : undefined;

    if (Array.isArray(customError)) {
      const conditionalCustomError = customError.find(
        (ce) => !ce.condition || ce.condition(errorResponse)
      );

      if (conditionalCustomError) {
        type = conditionalCustomError.type ?? type;
        headerKey = conditionalCustomError.headerKey ?? headerKey;
        textKey = conditionalCustomError.textKey ?? textKey;
      }
    } else if (customError) {
      const showCustomError =
        !customError.condition || customError.condition(errorResponse);

      if (showCustomError) {
        type = customError.type ?? type;
        headerKey = customError.headerKey ?? headerKey;
        textKey = customError.textKey ?? textKey;
      }
    }

    import('@allesauto/core/toastify').then((module) => {
      module.toastifyFactory(
        type as ToastifyType.ERROR,
        (intlFormat) => intlFormat(headerKey),
        (intlFormat) => intlFormat(textKey)
      );
    });
  }
}
